import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import NameFieldCard from "../../../../_utils/TransactionCommonComponents/NameFieldCard";

const RemitAccountStepConfirm = ({ accountPayLoad, setAccountPayLoad }) => {
  return (
    <>
      <div className="w-width-full max-w-tab-width-normal flex flex-col gap-y-gap-md">
        <div className="flex flex-col Qlg:flex-row lg:gap-gap-xl gap-gap-md Qmd:justify-between py-padding-md Qmd:py-padding-base px-padding-md Qlg:px-padding-base">
          <div className="w-width-full lg:w-width-md lg:max-w-[var(--create-box-width)]">
            <NameFieldCard
              title="Account Name"
              subHeader="Account name"
              value={accountPayLoad?.remitterAccountName}
              previewMode={true}
            />
          </div>
          <div className="w-width-full lg:w-width-md lg:max-w-[var(--create-box-width)]">
            <AssignLabels
              previewMode={true}
              labels={accountPayLoad?.labels}
              isOptional={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default RemitAccountStepConfirm;
